<script>
    import { portal } from "svelte-portal";
    import { onMount, createEventDispatcher } from "svelte";
    import { fly } from "svelte/transition";
    import PickerView from "./PickerView.svelte";
    const dispatch = createEventDispatcher();
    const date = new Date();
    const nowYear = date.getFullYear();
    const nowMonth = date.getMonth() + 1;
    const nowDay = date.getDate();
    const l10 = new Date().setFullYear(nowYear - 10);
    const f10 = new Date().setFullYear(nowYear + 10);
    const inow = date.getTime();
    export let title = "";
    export let confirmText = "确定";
    export let cancelText = "取消";
    export let precision = "day"; //精度
    export let min = l10; //10年前时间戳
    export let max = f10; //10年后时间戳
    export let defaultValue = inow;
    // export let value = inow;
    export let show = false;
    //静态数据供下面操作
    const dates = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    ];
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    //
    let yearItems = [];
    let monthItems = [];
    let dayItems = [];
    let _defaultY = nowYear;
    let _defaultM = nowMonth;
    let _defaultD = nowDay;
    let _defaultH = 0;
    let _defaultMinutes = 0;
    let _defaultS = 0;

    let clsName = "sui-date-picker";

    function datepickerListener(e) {
        const { val, name } = e.detail || {};
        const dateDefault = new Date(parseInt(defaultValue));
        if (name === "year" && val) {
            defaultValue = dateDefault.setFullYear(val);
        }
        if (name === "month" && val) {
            defaultValue = dateDefault.setMonth(val - 1);
        }
        if (name === "date" && val) {
            defaultValue = dateDefault.setDate(val);
        }
        setTimeout(calc, 0);
    }

    onMount(() => {
        calc();
    });
    //计算判断
    function calc() {
        //最小
        const minDate = new Date(parseInt(min));
        const minY = minDate.getFullYear();
        const minM = minDate.getMonth() + 1;
        const minD = minDate.getDate();
        const minH = minDate.getHours();
        const minMinutes = minDate.getMinutes();
        const minS = minDate.getSeconds();
        //最大
        const maxDate = new Date(parseInt(max));
        const maxY = maxDate.getFullYear();
        const maxM = maxDate.getMonth() + 1;
        const maxD = maxDate.getDate();
        const maxH = maxDate.getHours();
        const maxMinutes = maxDate.getMinutes();
        const maxS = maxDate.getSeconds();
        //当前
        const currentDate = new Date(parseInt(defaultValue));
        _defaultY = currentDate.getFullYear();
        _defaultM = currentDate.getMonth() + 1;
        _defaultD = currentDate.getDate();
        _defaultH = currentDate.getHours();
        _defaultMinutes = currentDate.getMinutes();
        _defaultS = currentDate.getSeconds();
        //判断
        let _isMaxY = maxY === _defaultY;
        let _isMaxM = _isMaxY && maxM === _defaultM;
        let _isMaxD = _isMaxM && maxD === _defaultD;

        let _isMinY = minY === _defaultY;
        let _isMinM = _isMinY && minM === _defaultM;
        let _isMinD = _isMinM && minD === _defaultD;
        //生成年的数组
        yearItems = createYears(minY, maxY);
        if (_isMinY) {
            //小年说明月和日都需要控制
            monthItems = months.slice(minM - 1);
            if (_isMinM || monthItems[0] === minM) {
                let maxDateLong = new Date(minY, minM, 0).getDate();
                dayItems = dates.slice(minD - 1, maxDateLong);
                return;
            }
            let maxDateLong = new Date(_defaultY, _defaultM, 0).getDate();
            dayItems = dates.slice(0, maxDateLong);
        } else if (_isMaxY) {
            //大年说明月和日都需要控制
            monthItems = months.slice(0, maxM);
            if (_isMaxM) {
                dayItems = dates.slice(0, maxD);
                return;
            }
            let maxDateLong = new Date(_defaultY, _defaultM, 0).getDate();
            dayItems = dates.slice(0, maxDateLong);
        } else {
            monthItems = months;
            let maxDateLong = new Date(_defaultY, _defaultM, 0).getDate();
            dayItems = dates.slice(0, maxDateLong);
        }
    }
    //生成years
    function createYears(s, b) {
        const hook = [];
        for (let i = s; i <= b; i++) {
            hook.push(i);
        }
        return hook;
    }
    //点击取消
    function handleCancel() {
        dispatch("cancel");
    }
    //点击确定
    function handleConfirm() {
        dispatch("confirm", defaultValue);
        dispatch("select", defaultValue);
    }
    //
    let el;
    function start() {
        setTimeout(() => {
            el.classList.add("show");
        });
    }
</script>

{#if show}
    <div
        class={`${clsName}-box`}
        transition:fly={{ y: 200, duration: 300 }}
        on:introstart={start}
        use:portal={"body"}
        bind:this={el}
    >
        <div class={clsName}>
            <div class={`${clsName}-actions`}>
                <div
                    role="button"
                    class={`${clsName}-actions-btn`}
                    on:click={handleCancel}
                >
                    {cancelText}
                </div>
                {#if title}
                    <h4>{title}</h4>
                {/if}
                <div
                    role="button"
                    class={`${clsName}-actions-btn`}
                    on:click={handleConfirm}
                >
                    {confirmText}
                </div>
            </div>
            <div class={`${clsName}-info`}>
                {#if precision === "year"}
                    {#if yearItems.length > 0}
                        <PickerView
                            unit="年"
                            name="year"
                            value={_defaultY}
                            on:change={datepickerListener}
                            items={yearItems}
                        />
                    {/if}
                {:else if precision === "month"}
                    {#if yearItems.length > 0}
                        <PickerView
                            unit="年"
                            name="year"
                            value={_defaultY}
                            on:change={datepickerListener}
                            items={yearItems}
                        />
                    {/if}
                    {#if monthItems.length > 0}
                        <PickerView
                            date={true}
                            unit="月"
                            name="month"
                            value={_defaultM}
                            on:change={datepickerListener}
                            items={monthItems}
                        />
                    {/if}
                {:else}
                    {#if yearItems.length > 0}
                        <PickerView
                            unit="年"
                            name="year"
                            value={_defaultY}
                            on:change={datepickerListener}
                            items={yearItems}
                        />
                    {/if}
                    {#if monthItems.length > 0}
                        <PickerView
                            date={true}
                            unit="月"
                            name="month"
                            value={_defaultM}
                            on:change={datepickerListener}
                            items={monthItems}
                        />
                    {/if}
                    {#if dayItems.length > 0}
                        <PickerView
                            date={true}
                            unit="日"
                            name="date"
                            value={_defaultD}
                            on:change={datepickerListener}
                            items={dayItems}
                        />
                    {/if}
                {/if}
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    @import "./datepicker.less";
</style>
